module.exports = __webpack_public_path__ + "static/media/Ichikawa_legend.d6ff6300.png";